import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';
import WarpSpeedEffect from '../WarpSpeedEffect/WarpSpeedEffect';
import IntroSequence from '../IntroSequence/IntroSequence';

function LandingPage() {
  const [showIntro, setShowIntro] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (showIntro) return;

    const handleMouse = (event) => {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) return;

      const leftLayer = document.querySelector(".layer.left");
      const rightLayer = document.querySelector(".layer.right");
      const content = document.querySelector(".content-wrapper");
      const prompt = document.querySelector(".interaction-prompt");

      if (!leftLayer || !rightLayer || !content || !prompt) return;

      const mouseX = event.clientX / window.innerWidth;

      leftLayer.style.transform = `translateX(${-50 + mouseX * 50}%)`;
      rightLayer.style.transform = `translateX(${50 - mouseX * 50}%)`;

      if (mouseX > 0.4 && mouseX < 0.6) {
        content.style.opacity = "1";
        content.style.transform = "translateY(0)";
        prompt.classList.add("hidden");
      } else {
        content.style.opacity = "0";
        content.style.transform = "translateY(50px)";
        prompt.classList.remove("hidden");
      }
    };

    const timeoutId = setTimeout(() => {
      document.addEventListener("mousemove", handleMouse);
    }, 100);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("mousemove", handleMouse);
    };
  }, [showIntro]);

  return showIntro ? (
    <IntroSequence
      onComplete={() => {
        setShowIntro(false);
        navigate('/home');
      }}
    />
  ) : (
    <>
      <WarpSpeedEffect />
      <div className="layer left"></div>
      <div className="layer right"></div>

      <div className="interaction-prompt">
        <span className="desktop-prompt">Point Here</span>
        <span className="mobile-prompt">Swipe here</span>
      </div>

      <div className="content-wrapper">
        <button className="enter-button" onClick={() => navigate('/home')}>Welcome</button>
        <button className="intro-button" onClick={() => setShowIntro(true)}>Watch Intro</button>
      </div>
    </>
  );
}

export default LandingPage;
